export let blobList = [
    "Africa",
    "East Asia",
    "South East Asia",
    "India",
    "UAE",
    "UK",
    "US East",
    "US North",
    "US West",
    "West Europe"
];

